import { eventPost } from '@/lib/events';
import { currentUpdaterRole } from '@/config/program';
import { isVisitKind, type VisitKind } from '@/logic/visits';

export interface RequestAppointmentOpts {
  /** Which visit the patient is asked to book; WF33 picks the link, the title and the guard from it. */
  visitKind: VisitKind;
  sendSms?: boolean;
  sentByRole?: string;
  sentBy?: string | number;
  sentByFirstname?: string;
  sentByLastname?: string;
}

export async function requestAppointment(
  withingsUserId: string | number,
  {
    visitKind,
    sendSms = true,
    sentByRole = currentUpdaterRole(),
    sentBy,
    sentByFirstname,
    sentByLastname,
  }: RequestAppointmentOpts,
): Promise<unknown> {
  // Callers are .jsx, so the type alone enforces nothing: WF33 would read a missing kind as an older app.
  if (!isVisitKind(visitKind)) throw new Error('A visit kind (cc or np) is required');
  return eventPost('appointment_requested', {
    id_dev_user: String(withingsUserId),
    visit_kind: visitKind,
    send_sms: sendSms,
    actor: {
      role: sentByRole,
      ...(sentBy ? { user_id: sentBy } : {}),
      ...(sentByFirstname ? { firstname: sentByFirstname } : {}),
      ...(sentByLastname ? { lastname: sentByLastname } : {}),
    },
  });
}
